import { createFileRoute } from '@tanstack/react-router'

import { AdminAssetsPage } from '@/pages/admin/assets/admin-assets-page'

export const Route = createFileRoute('/_private/admin/assets')({
  component: AdminAssetsPage,
})
